import { render, staticRenderFns } from "./BillDetSumStrgQtyIndex.vue?vue&type=template&id=4ef8fda6&scoped=true&"
import script from "./BillDetSumStrgQtyIndex.vue?vue&type=script&lang=js&"
export * from "./BillDetSumStrgQtyIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillDetSumStrgQtyIndex.vue?vue&type=style&index=0&id=4ef8fda6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8fda6",
  null
  
)

export default component.exports